var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gnetFormMask',{attrs:{"sections":_vm.sections},on:{"click":function($event){return _vm.toggleSection($event)},"change":function($event){return _vm.setField($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }